import React, {useState, useEffect} from 'react'
import Section from './Section'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles'
import Markdown from '../ui/Markdown'
import Fade from '@material-ui/core/Fade';
import useMediaQuery from '@material-ui/core/useMediaQuery'

import Slider from "react-slick";
import NextArrow from '../ui/NextArrow'
import PrevArrow from '../ui/PrevArrow'
import Box from '@material-ui/core/Box'
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

const styles = theme => ({
    root: {
      display: 'flex',
      overflow: 'hidden',
    },
    // Must use custom background div or it will overlap with section backdrop/image
    background: {
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      zIndex: -3,
    },  
    item: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
  //    padding: theme.spacing(0, 3),
    },
    carouselItem:{
        position: 'absolute',
        width: '100%',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        height: '100vh',
      [theme.breakpoints.between('md','sm')]:{
        marginTop: theme.spacing(3),
        padding: 0,
      },
      [theme.breakpoints.down('xs')]:{
        // marginRight: theme.spacing(1) * -2,
        // marginLeft: theme.spacing(1) * -2,
        marginBottom: theme.spacing(3)
      }
    },
    relativeCarouselActive:{
      position:'relative',
      height: '100%',
      display: 'block',
    },
    relativeCarousel:{
      position: 'relative',
      height: '100%',
      display: 'none',
    },
    fullHeight:{
        position: 'absolute',
        width: '100%',
        height: '100vh',
        top: 0,
        left: 0,
        background: 'white'
    },
    textCarousel:{
      position: 'absolute',
      top: 0,
      width: '100%',
      height: '100vh'
    },
    detailText:{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      flexDirection: 'column'
    },
    chevronPrev:{
      position: 'absolute',
      top: '50%',
      left: theme.spacing(2),
      [theme.breakpoints.down('sm')]: {
        left: theme.spacing(0),
      },
      cursor: 'pointer',
    },
    chevronNext:{
      position: 'absolute',
      top: '50%',
      right: theme.spacing(2),
      [theme.breakpoints.down('sm')]: {
        right: theme.spacing(0),
      },
      cursor: 'pointer'
    },
    iconChevron:{
      fontSize: '4rem',
      color: 'white',
      [theme.breakpoints.down('sm')]: {
        fontSize: '2rem',
      }
    },
    opacityAnimate:{
      opacity: 0.125
    },
    carouselDots:{
      position:'absolute',
      bottom: theme.spacing(3),
      width: '100%',
      display: 'flex',
      justifyContent: 'center'
    },
    dotsItem:{
      backgroundColor: 'black',
      border: '3px solid white',
      borderRadius: '50%',
      display: 'inline-block',
      height: '10px',
      width: '10px',
      margin: theme.spacing(0.4),
      cursor: 'pointer'
    },
    dotsItemActive:{
      backgroundColor: 'white',
      border: '3px solid black',
      borderRadius: '50%',
      display: 'inline-block',
      height: '10px',
      width: '10px',
      margin: theme.spacing(0.4),
      cursor: 'pointer'
    }
  });

const CarouselSection = (props) => {

  const { theme, classes, key, sectionIndex, openLink, color, createContentBlock, item_spacing, children } = props
  const { items } = props

  const sectionProp = {
    section_height: props.section_height,
    section_width: props.section_width,
    content_width: props.content_width,
    vertical_alignment: props.vertical_alignment,
    horizontal_alignment: props.horizontal_alignment,
    overlay_opacity: props.overlay_opacity,
    color: props.color,
    text_alignment: props.text_alignment,
    button_style: props.button_style,
    item_spacing:item_spacing
  }

  let smUp = useMediaQuery(theme.breakpoints.up('sm'))

  let backgroundColor = theme.sectionPalette.white.background
  if (color == 'light')
    backgroundColor = theme.sectionPalette.light.background
  else if (color == 'dark')
    backgroundColor = theme.sectionPalette.dark.background
  else if (color == 'accent')
    backgroundColor = theme.sectionPalette.accent.background
  else if (color == 'black')
    backgroundColor = theme.sectionPalette.black.background

  const [activeIndex, setActiveIndex] = useState(0)
  const [visible, setVisible] = useState(false)

  const nextCarousel = () => {
    let index = activeIndex
    if(index === (items.length-1)){
      setVisible(true)
      setActiveIndex(0)
      setTimeout(() => {
        setVisible(false)
      }, 300);
    }else{
      setVisible(true)
      setActiveIndex(++index)
      setTimeout(() => {
        setVisible(false)
      }, 300);
    }
  }

  const prevCarousel = () => {
    let index = activeIndex
    if(index === 0){
      setVisible(true)
      setActiveIndex(items.length-1)
      setTimeout(() => {
        setVisible(false)
      }, 300);
    }else{
      setVisible(true)
      setActiveIndex(--index)
      setTimeout(() => {
        setVisible(false)
      }, 300);
    }
  }

  useEffect(() => {
    const interval = setInterval(() => {
      nextCarousel()
    }, 5000);
    return () => clearInterval(interval);
  }, [activeIndex]);
  
  /*
  const itemProp = {
    title: items[activeIndex].title,
    subtitle: items[activeIndex].subtitle,
    body: items[activeIndex].body,
    link_to: items[activeIndex].link_to,
    button_title: items[activeIndex].button_title,
    background_images: items[activeIndex].images,
  }
  */

  return (
      <div style={{ height: '100vh'}}>
        { items.map((item, index) =>
          <div style={{ position: "absolute", left: 0, top: 0, width: '100%', opacity: 1.0 }}>
            <Fade in={activeIndex==index ? true : false} timeout={1000}>
              <Box>
              <Section
                openLink={ openLink } createContentBlock={ createContentBlock } sectionIndex={ sectionIndex } 
                { ...sectionProp }
                { ...{
                  title: item.title,
                  subtitle: item.subtitle,
                  body: item.body,
                  link_to: item.link_to,
                  button_title: item.button_title,
                  background_images: item.images
                }}>
              </Section>
              </Box>
            </Fade>
          </div>
          )
        }
        <>
          <Box className={classes.chevronNext} onClick={nextCarousel}>
            <ChevronRightIcon className={classes.iconChevron}/>
          </Box>
          <Box className={classes.chevronPrev} onClick={prevCarousel}>
            <ChevronLeftIcon className={classes.iconChevron}/>
          </Box>
        </>
        <Box className={classes.carouselDots}>
          {items.map((item,index) => (
            <span className={activeIndex === index ? classes.dotsItemActive : classes.dotsItem} onClick={()=>setActiveIndex(index)}></span>
          ))}
        </Box>
        <div className={classes.background} style={{ backgroundColor: backgroundColor}} />
      </div>
  )
}

CarouselSection.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(CarouselSection);